import { useTranslation } from 'react-i18next';

export default function CallToAction() {
  const { t } = useTranslation('common');

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="rounded-3xl overflow-hidden shadow-2xl relative h-96">
          <img 
            src="https://public.readdy.ai/ai/img_res/ba44ba3de593ba2f31e6e069b143f1ed.jpg"
            alt="Legal Consultation"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-8">
            <h2 className="text-5xl font-serif text-white mb-6 leading-tight max-w-3xl">
              {t('cta.title1')}<br />
              <span className="font-bold italic">{t('cta.title2')}</span>
            </h2>
            
            <p className="text-lg text-gray-200 mb-8 max-w-2xl">
              {t('cta.description')}
            </p>
            
            <a href="#consultation" className="px-10 py-4 bg-amber-600 text-white text-base font-semibold rounded-full hover:bg-amber-700 transition-all cursor-pointer whitespace-nowrap">
              {t('cta.button')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
